<template>
  <div>
    <paginated-data-table
      ref="table"
      :headers="headers"
      :search="search"
      :query="query"
      :custom-items-per-page="5"
      queryName="pointsTransactions"
      :queryVariables="queryVariables"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>
            <span :style="{ color: item.amount >= 0 ? 'green' : 'red' }">{{ item.amount }}</span>
          </td>
          <td>
            {{ getTypeDescription(item.type) }}
          </td>
          <td>
            {{ getSafe(() => item.unit.name) || '-' }}
          </td>
          <td>
            {{ item.created_at | date({ fmtIn: 'yyyy-MM-dd HH:mm:ss', fmtOut: 'dd/MM/yyyy | HH:mm:ss' }) }}
          </td>
        </tr>
      </template>
    </paginated-data-table>
  </div>
</template>

<script>
import { QUERY_GET_POINTS_TRANSACTIONS } from '@/modules/clientes/gerenciamento/graphql'
import { createCsvFromArray } from '@/config/helpers.js'
import { DateTime } from 'luxon'
export default {
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
  },
  props: {
    user: Object,
  },
  data: () => ({
    search: null,
  }),
  computed: {
    loading() {
      return this.$refs?.table?.paginationLoading
    },
    headers() {
      return [
        {
          text: 'Pontos',
          value: 'amount',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Tipo',
          value: 'type',
          width: '20%',
          sortable: false,
        },
        {
          text: 'Loja',
          value: 'unit.name',
          width: '35%',
          sortable: false,
        },
        {
          text: 'Data',
          value: 'created_at',
          width: '30%',
          sortable: false,
        },
      ]
    },
    query() {
      return QUERY_GET_POINTS_TRANSACTIONS
    },
    queryVariables() {
      return {
        userDocumentNo: this.user.document_no,
      }
    },
  },
  methods: {
    getTypeDescription(type) {
      const typeToDescription = {
        purchase: 'Vale-troca por compra',
        purchase_canceled: 'Vale-troca de compra cancelada',
        points_expired: 'Vale-troca expirado',
        points_campaign: 'Vale-troca de campanha de pontos',
        points_readjusted: 'Vale-troca reajustado',
        points_blocked: 'Vale-troca bloqueado',
        voucher_purchased: 'Vale-troca comprado',
        voucher_canceled: 'Vale-troca cancelado',
        voucher_expired: 'Vale-troca expirado',
        voucher_consumed: 'Vale-troca utilizado',
      }
      return typeToDescription[type] || '-'
    },
    async exportCSV() {
      const { data } = await this.$apollo.query({
        query: this.query,
        variables: this.queryVariables,
        fetchPolicy: 'no-cache',
      })
      const rows = data.pointsTransactions.pointsTransactions.map((transaction) => ({
        pontos: transaction.amount,
        tipo: this.getTypeDescription(transaction.type),
        loja: transaction.unit?.name || '-',
        data: DateTime.fromFormat(transaction.created_at, 'yyyy-MM-dd HH:mm:ss').toFormat('dd/MM/yyyy HH:mm:ss'),
      }))
      const headers = ['Pontos', 'Tipo', 'Loja', 'Data']
      createCsvFromArray(rows, `historico_pontos_${this.user.document_no}`, headers)
    },
  },
}
</script>
